import React from 'react';
import './subTitle.scss';

const SubTitle = ({children}: any) => {
  return (
    <h2 className="sub-title">{children}</h2>
  );
}

export default SubTitle;
